import { CENTRA_ROUTE_SCHEMA, EVENTS_NAME, CENTRA_EVENT_ROUTES } from '../consts/common';

/** Функция для поиска событий в объекте определенных либой. */
export const isEvent = (event?: string): boolean =>
  Boolean(event && (event.startsWith(CENTRA_ROUTE_SCHEMA) || Object.values(EVENTS_NAME).find((e) => e === event)));

/** Возвращает ссылку для получения роута внутреннего события */
export const getInternalEventRoute = (route: typeof CENTRA_EVENT_ROUTES) => {
  if (typeof route !== 'string') return '';

  return CENTRA_ROUTE_SCHEMA + route;
};

type TResult = { event?: string; params?: { [x: string]: string } };

/**
 * Проверка, является ли событие событием внутреннего роута
 * возвращает название роута и query параметры в объекте
 */
export const getInternalEventName = (link: string): TResult => {
  const result: TResult = {};

  if (typeof link !== 'string') return result;

  const currentLink = new URL(link);
  //ToDo: надо пофиксить двойной слеш у `//${r}`

  //Safari и другие браузеры по разному парсят ссылку
  const linkEvent = currentLink.pathname ? currentLink.pathname.replace('//', '') : currentLink.host;

  if (linkEvent) {
    const event = Object.values(CENTRA_EVENT_ROUTES).find((r) => r === linkEvent);
    result.event = event;
  }

  if (currentLink.search) {
    const params = currentLink.search.replace('?', '');
    const paramsList = params.split('&');
    const p = paramsList.reduce((acc, p) => {
      const [key] = p.split('=');
      acc[key] = currentLink.searchParams.get(key);
      return acc;
    }, {});

    result.params = p;
  }

  return result;
};
